import { apiClient } from "./client";
import { PropallySmaulV1ApiFactory, type SmaulLeadRequest } from "./generated";

const smaulApi = PropallySmaulV1ApiFactory(undefined, undefined, apiClient);

export const createSmaulLead = (payload: SmaulLeadRequest) => {
  return smaulApi.smaulV1LeadsPost(payload);
};
